import FilesExplorer from './FilesExplorer';

export default FilesExplorer;
